import React from "react";
import { ReactComponent as GroupGradient } from "../../../../assets/icons/svg/group-gradient.svg";
import { ReportKpi } from "../model/types";
import classes from "./Banner.module.less";

interface Props {
    headline: React.ReactNode;
    kpis: ReportKpi[];
    alertIndex?: number;
}

export const Banner: React.FC<Props> = ({ headline, kpis, alertIndex }) => (
    <div className={classes.container}>
        <div className={classes.top}>
            <GroupGradient />
            <span className={classes.headline}>{headline}</span>
        </div>
        <div className={classes.metrics}>
            {kpis.map((k, i) => (
                <div key={k.label} className={classes.metricBox}>
                    <div className={classes.metricLabel}>{k.label}</div>
                    <div
                        className={`${classes.metricValue} ${i === alertIndex ? classes.alert : ""}`}
                    >
                        {k.value}
                    </div>
                    <div className={classes.metricDerived}>{k.detail}</div>
                </div>
            ))}
        </div>
    </div>
);
